import { Badge } from '@minna-technologies/minna-ui/components/Badge';
import React from 'react';

export const BetaTag: React.FunctionComponent = () => <Badge label={'BETA'} />;
